// Handoff de identidad del portal hacia SDP-Logística.
//
// Reusa la sesión Firebase del backoffice sin pedir un segundo login:
//   1. refresca el ID token Firebase de la sesión actual,
//   2. lo canjea en Logística por un código de handoff efímero (60s),
//   3. abre el SPA de Logística con ese código en el fragment (#h=...),
//      que no viaja a servidores ni queda en logs.
//
// Es la única pieza del backoffice que conoce Logística; todo lo demás queda
// desacoplado.
const LOGISTICA_BASE_URL = process.env.REACT_APP_LOGISTICA_URL;

export default async function openLogistica(application) {
    if (!LOGISTICA_BASE_URL) {
        throw new Error('REACT_APP_LOGISTICA_URL no está configurada');
    }

    // Abrimos la pestaña ya, dentro del gesto del click, para no ser bloqueados
    // por el popup blocker; la apuntamos al destino recién con el código listo.
    const logisticaTab = window.open('about:blank', '_blank');

    try {
        const session = application.session();
        await session.refreshUserToken();
        const firebaseIdToken = session.getToken();

        const response = await fetch(`${LOGISTICA_BASE_URL}/api/auth/exchange`, {
            method: 'POST',
            headers: {Authorization: `Bearer ${firebaseIdToken}`},
        });
        if (!response.ok) {
            throw new Error('No se pudo iniciar sesión en Logística');
        }

        const {handoffCode} = await response.json();
        const destination = `${LOGISTICA_BASE_URL}/#h=${encodeURIComponent(handoffCode)}`;
        if (logisticaTab) {
            logisticaTab.location.href = destination;
        } else {
            window.location.assign(destination);
        }
    } catch (error) {
        if (logisticaTab) {
            logisticaTab.close();
        }
        throw error;
    }
}
